export default "__VITE_ASSET__BCNsfh6Y__"